import { getInstitutionByIP } from "@/services/SubscriptionService.js";

// In-flight lookup, shared by every caller of fetchInstitution.
let inFlight = null;
// True once this page load has resolved a real answer. `state.loaded` cannot
// stand in for this: vuex-persist rehydrates it from a previous visit.
let resolvedThisSession = false;

export const subscriptionStatus = {
  namespaced: true,
  state: {
    institution: null,
    status: null,
    loaded: false, // to track if the data has been loaded
  },
  getters: {
    institution: (state) => state.institution,
    status: (state) => state.status,
    // enable status for local detail page test and other things without logging in
    // status: (state) => "subscribed",
    isLoaded: (state) => state.loaded,
  },
  mutations: {
    setInstitution(state, payload) {
      state.institution = payload.institution;
      state.status = payload.status;
      state.loaded = true;
    },
    resetInstitution(state) {
      state.institution = null;
      state.status = null;
      state.loaded = false;
    },
  },
  actions: {
    async fetchInstitution({ commit, state }) {
      // Share one request between concurrent callers, otherwise two lookups
      // can resolve out of order and the later one wins.
      if (inFlight) return inFlight;
      inFlight = (async () => {
        let response = await getInstitutionByIP();
        // getInstitutionByIP returns [] on failure; a genuine "no subscription"
        // comes back as an object with status "not subscribed". Don't let a
        // failed request clear a status this page load already resolved.
        if (Array.isArray(response)) {
          if (!resolvedThisSession) {
            commit("resetInstitution");
          }
        } else {
          commit("setInstitution", {
            institution: response.name,
            status: response.status,
          });
          resolvedThisSession = true;
        }
      })();
      try {
        await inFlight;
      } finally {
        inFlight = null;
      }
    },

    // Use this when the answer has to be trustworthy: joins an in-flight
    // lookup, fetches when this page load has no answer yet, else no-ops.
    async ensureInstitution({ dispatch }) {
      if (inFlight) return inFlight;
      if (resolvedThisSession) return;
      return dispatch("fetchInstitution");
    },
  },
};
